// Perfil on Firebase: the account is the signed-in uid, as for Dados gerais
// (firebaseOnboarding), and "Terminar" closes the Firebase session, which
// also drops the session Firebase persisted on the device.

import { dataLayer } from "../data";
import { firebaseOnboarding } from "../onboarding/firebaseOnboarding";
import type { ProfileSession } from "./profile";

export const firebaseProfile: ProfileSession = {
  accountId: firebaseOnboarding.accountId,
  data: dataLayer,
  async signOut() {
    // Loaded on demand, like every Firebase use: firebase.ts throws while the
    // config is blank (HANDOFF.md, step F5).
    const [{ auth }, { signOut }] = await Promise.all([import("../lib/firebase"), import("firebase/auth")]);
    await signOut(auth);
  },
};
